// extracted by mini-css-extract-plugin
module.exports = {"text1Line":"styles_text1Line__wWv0A","ellipsis":"styles_ellipsis__WMBry","text2AndMoreLines":"styles_text2AndMoreLines___lHi_","tooltipTrigger":"styles_tooltipTrigger__IzcwR"};